import React from 'react'
import { Button } from '@mui/material'
import { bool, func, any } from 'prop-types'
export default function ButtonVideoIOS({ isIOS, resumo, onClick, hasFile }) {
  return (
    <>
      {isIOS && (
        <Button
          disabled={!!resumo}
          onClick={onClick}
          sx={{
            display: hasFile ? 'none' : 'block',
            padding: '0.5rem 3rem',
            color: 'white',
            height: 'max-content'
          }}
          variant="contained"
          color="orange"
        >
          Importar
        </Button>
      )}
    </>
  )
}
ButtonVideoIOS.propTypes = {
  isIOS: bool,
  resumo: any,
  onClick: func,
  hasFile: bool
}
